import body_back from "./fixture_images/body_back.png";
import body_front from "./fixture_images/body_front.png";
import generic_face from "./fixture_images/generic_face.png";
import forearm_map from "./fixture_images/forearm_map.png";
import right_forearm_flexed from "./fixture_images/right_forearm_flexed.png";
import right_forearm_extended from "./fixture_images/right_forearm_extended.png";
import left_forearm_flexed from "./fixture_images/left_forearm_flexed.png";
import left_forearm_extended from "./fixture_images/left_forearm_extended.png";
import abdomenLeft from "./fixture_images/abdomenLeft.png";
import abdomenRight from "./fixture_images/abdomenRight.png";
import ankleBackLeft from "./fixture_images/ankleBackLeft.png";
import ankleBackRight from "./fixture_images/ankleBackRight.png";
import ankleFrontLeft from "./fixture_images/ankleFrontLeft.png";
import ankleFrontRight from "./fixture_images/ankleFrontRight.png";
import calfLeft from "./fixture_images/calfLeft.png";
import calfRight from "./fixture_images/calfRight.png";
import thighLeft from "./fixture_images/thighLeft.png";
import thighRight from "./fixture_images/thighRight.png";
import chestLeft from "./fixture_images/chestLeft.png";
import chestRight from "./fixture_images/chestRight.png";
import dorsalHandRight from "./fixture_images/dorsalHandRight.png";
import dorsalHandLeft from "./fixture_images/dorsalHandLeft.png";
import fingerLeft from "./fixture_images/fingerLeft.png";
import fingerRight from "./fixture_images/fingerRight.png";
import forearmExtensorLeft from "./fixture_images/forearmExtensorLeft.png";
import forearmExtensorRight from "./fixture_images/forearmExtensorRight.png";
import lowerBackLeft from "./fixture_images/lowerBackLeft.png";
import lowerBackRight from "./fixture_images/lowerBackRight.png";
import toeLeft from "./fixture_images/toeLeft.png";
import toeRight from "./fixture_images/toeRight.png";
import upperBackLeft from "./fixture_images/upperBackLeft.png";
import upperBackRight from "./fixture_images/upperBackRight.png";
import upperArmFlexorRight from "./fixture_images/upperArmFlexorRight.png";
import upperArmFlexorLeft from "./fixture_images/upperArmFlexorLeft.png";
import upperArmExtensorRight from "./fixture_images/upperArmExtensorRight.png";
import upperArmExtensorLeft from "./fixture_images/upperArmExtensorLeft.png";
import forearmFlexorLeft from "./fixture_images/forearmFlexorLeft.png";
import forearmFlexorRight from "./fixture_images/forearmFlexorRight.png";
export const TRAINING_PROTOCOL = {
  protocolId: "TRAINING_PROTOCOL",
  protocolName: "Training Protocol",
  modified: false,
  locations: {
    INNER_FOREARM_FLEXED_RIGHT: {
      name: "Inner Forearm Flexed (R)",
      samples_needed: {
        BMODE: 1,
        CSI: 3,
      },
      notes: null,
      maps: {
        ForearmMap: [
          29.008196721311474, 35.01945525291829, 26.87704918032787,
          28.59922178988327, 23.598360655737704, 29.182879377431906,
          20.975409836065573, 29.766536964980546, 18.516393442622952,
          30.544747081712064, 19.172131147540984, 35.60311284046693,
          22.28688524590164, 35.60311284046693, 25.729508196721312,
          35.60311284046693,
        ],
      },
      instruction: {
        text: 'The participant should have their right arm flexed with their elbow bent. The target region is a horizontal band, 2-3" wide, located 1" below the elbow.',
        illustration: [
          {
            image: right_forearm_flexed,
            filename: "right_forearm_flexed",
          },
        ],
      },
      parameters_id: "STL",
    },
    INNER_FOREARM_EXTENDED_RIGHT: {
      name: "Inner Forearm Extended (R)",
      samples_needed: {
        BMODE: 1,
        CSI: 3,
      },
      notes: null,
      maps: {
        ForearmMap: [
          20.31967213114754, 81.90661478599222, 16.71311475409836,
          77.62645914396887, 14.254098360655737, 80.73929961089495,
          12.12295081967213, 83.26848249027238, 13.762295081967213,
          87.35408560311284, 17.204918032786885, 84.63035019455253,
        ],
      },
      instruction: {
        text: 'The participant should have their right arm fully extended. The target region is a horizontal band, 2-3" wide, located 1" below the elbow.',
        illustration: [
          {
            image: right_forearm_extended,
            filename: "right_forearm_extended",
          },
        ],
      },
      parameters_id: "STL",
    },
    INNER_FOREARM_FLEXED_LEFT: {
      name: "Inner Forearm Flexed (L)",
      samples_needed: {
        BMODE: 1,
        CSI: 3,
      },
      notes: null,
      maps: {
        ForearmMap: [
          70.49180327868852, 35.01945525291829, 72.62295081967213,
          28.59922178988327, 75.90163934426229, 29.182879377431906,
          78.52459016393442, 29.766536964980546, 80.98360655737704,
          30.544747081712064, 80.32786885245902, 35.60311284046693,
          77.21311475409836, 35.60311284046693, 73.77049180327869,
          35.60311284046693,
        ],
      },
      instruction: {
        text: 'The participant should have their left arm flexed with their elbow bent. The target region is a horizontal band, 2-3" wide, located 1" below the elbow.',
        illustration: [
          {
            image: left_forearm_flexed,
            filename: "left_forearm_flexed",
          },
        ],
      },
      parameters_id: "STL",
    },
    INNER_FOREARM_EXTENDED_LEFT: {
      name: "Inner Forearm Extended (L)",
      samples_needed: {
        BMODE: 1,
        CSI: 3,
      },
      notes: null,
      maps: {
        ForearmMap: [
          79.18032786885246, 81.90661478599222, 82.78688524590164,
          77.62645914396887, 85.24590163934427, 80.73929961089495,
          87.37704918032787, 83.26848249027238, 85.73770491803279,
          87.35408560311284, 82.29508196721312, 84.63035019455253,
        ],
      },
      instruction: {
        text: 'The participant should have their left arm fully extended. The target region is a horizontal band, 2-3" wide, located 1" below the elbow.',
        illustration: [
          {
            image: left_forearm_extended,
            filename: "left_forearm_extended",
          },
        ],
      },
      parameters_id: "STL",
    },
  },
  maps: {
    ForearmMap: {
      name: "Forearm Map",
      image: forearm_map,
      filename: "forearm_map.png",
    },
  },
  parameters: {
    STL: {
      name: "STL",
    },
  },
  acq_types: {
    BMODE: {
      name: "T-Mode",
    },
    CSI: {
      name: "E-Mode",
    },
  },
};

export const CUSTOM_PROTOCOL = {
  protocolId: "CUSTOM",
  protocolName: "Make a Custom Protocol",
  modified: false,
  locations: {},
  maps: {
    Front: {
      name: "Front",
      image: body_front,
      filename: "body_front.png",
    },
    Back: {
      name: "Back",
      image: body_back,
      filename: "body_back.png",
    },
    FACE_MAP: {
      name: "Face Map",
      image: generic_face,
      filename: "generic_face.png",
    },
  },
  parameters: {
    SINGLE: { name: "Default" },
    STL: { name: "STL" },
    MMODE: { name: "M-mode" },
  },
  acq_types: {
    BMODE: {
      name: "T-Mode",
    },
    CSI: {
      name: "E-Mode",
    },
  },
};
export const PresetLocations = {
  CHEEK_RIGHT: {
    locationName: "Cheek (R)",
    locationId: "CHEEK_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [],
    },
    maps: {
      Front: [
        41.6195856873823, 6.709039548022599, 46.13935969868173,
        7.2740112994350286, 45.38606403013183, 9.533898305084746,
        41.24293785310734, 8.686440677966102,
      ],
    },
  },
  CHEEK_LEFT: {
    locationName: "Cheek (L)",
    locationId: "CHEEK_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [],
    },
    maps: {
      Front: [
        58.3804143126177, 6.709039548022599, 53.86064030131827,
        7.2740112994350286, 54.61393596986817, 9.533898305084746,
        58.75706214689266, 8.686440677966102,
      ],
    },
  },
  FINGER_RIGHT: {
    locationName: "Finger (R)",
    locationId: "FINGER_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",

      illustration: [
        {
          image: fingerRight,
          filename: "fingerRight.png",
        },
      ],
    },
    maps: {
      Front: [
        4.8964218455743875, 50.63559322033898, 2.2598870056497176,
        52.048022598870055, 1.3182674199623352, 53.24858757062147,
        0.18832391713747645, 54.02542372881356, 2.071563088512241,
        53.954802259887, 4.143126177024482, 52.824858757062145,
        5.4613935969868175, 53.036723163841806, 3.0131826741996233,
        57.41525423728814, 4.3314500941619585, 57.76836158192091,
        5.649717514124294, 56.779661016949156, 6.779661016949152,
        55.720338983050844, 6.967984934086629, 56.92090395480226,
        5.4613935969868175, 58.333333333333336, 6.214689265536723,
        58.898305084745765, 9.227871939736346, 57.909604519774014,
        13.370998116760829, 56.42655367231639, 14.87758945386064,
        55.01412429378531, 15.819209039548022, 53.53107344632768,
      ],
    },
  },
  FINGER_LEFT: {
    locationName: "Finger (L)",
    locationId: "FINGER_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: fingerLeft,
          filename: "fingerLeft.png",
        },
      ],
    },
    maps: {
      Front: [
        95.1035781544256, 50.63559322033898, 97.74011299435028,
        52.048022598870055, 98.68173258003766, 53.24858757062147,
        99.81167608286252, 54.02542372881356, 97.92843691148776,
        53.954802259887, 95.85687382297552, 52.824858757062145,
        94.53860640301318, 53.036723163841806, 96.98681732580037,
        57.41525423728814, 95.66854990583803, 57.76836158192091,
        94.35028248587571, 56.779661016949156, 93.22033898305085,
        55.720338983050844, 93.03201506591337, 56.92090395480226,
        94.53860640301318, 58.333333333333336, 93.78531073446328,
        58.898305084745765, 90.77212806026365, 57.909604519774014,
        86.62900188323917, 56.42655367231639, 85.12241054613936,
        55.01412429378531, 84.18079096045197, 53.53107344632768,
      ],
    },
  },
  TOE_RIGHT: {
    locationName: "Toe (R)",
    locationId: "TOE_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: toeRight,
          filename: "toeRight.png",
        },
      ],
    },
    maps: {
      Front: [
        40.68455743879473, 98.23446327683615, 39.55461393596987,
        99.0819209039548, 38.048022598870055, 99.85875706214689,
        35.97645951035781, 99.85875706214689, 35.97645951035781,
        98.87005649717514, 35.22316384180791, 98.44632768361582,
        34.09322033898305, 98.94067796610169, 33.33992467043314,
        99.64689265536722, 31.080037664783426, 99.36440677966101,
        28.631826741996232, 98.65819209039547, 27.69020715630885,
        97.95197740112994, 27.87853107344633, 96.96327683615819,
        29.573446327683616, 96.32768361581921,
      ],
    },
  },
  TOE_LEFT: {
    locationName: "Toe (L)",
    locationId: "TOE_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: toeLeft,
          filename: "toeLeft.png",
        },
      ],
    },
    maps: {
      Front: [
        57.81544256120527, 98.23446327683615, 58.94538606403013,
        99.0819209039548, 60.451977401129945, 99.85875706214689,
        62.52354048964219, 99.85875706214689, 62.52354048964219,
        98.87005649717514, 63.27683615819209, 98.44632768361582,
        64.40677966101696, 98.94067796610169, 65.16007532956685,
        99.64689265536722, 67.41996233521657, 99.36440677966101,
        69.86817325800376, 98.65819209039547, 70.80979284369114,
        97.95197740112994, 70.62146892655367, 96.96327683615819,
        68.92655367231639, 96.32768361581921,
      ],
    },
  },
  UPPER_ARM_FLEXOR_LEFT: {
    locationName: "Upper Arm Flexor (L)",
    locationId: "UPPER_ARM_FLEXOR_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: upperArmFlexorLeft,
          filename: "upperArmFlexorLeft.png",
        },
      ],
    },
    maps: {
      Front: [
        81.35593220338983, 20.40960451977401, 83.05084745762711,
        21.89265536723164, 84.18079096045197, 23.44632768361582,
        83.61581920903954, 25.0, 83.42749529190208, 26.059322033898304,
        83.2391713747646, 27.11864406779661, 83.80414312617702,
        28.24858757062147, 84.55743879472693, 29.661016949152543,
        84.18079096045197, 31.14406779661017, 83.80414312617702,
        32.27401129943503, 84.18079096045197, 33.40395480225989,
        73.6346516007533, 34.53389830508475, 73.06967984934087,
        33.26271186440678, 72.69303201506591, 32.06214689265537,
        71.56308851224105, 31.497175141242938, 70.99811676082862,
        28.46045197740113, 70.80979284369114, 24.364406779661017,
        71.56308851224105, 21.75141242937853, 74.76459510357816,
        20.550847457627118, 78.3427495291902, 20.127118644067796,
      ],
    },
  },
  UPPER_ARM_FLEXOR_RIGHT: {
    locationName: "Upper Arm Flexor (R)",
    locationId: "UPPER_ARM_FLEXOR_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: upperArmFlexorRight,
          filename: "upperArmFlexorRight.png",
        },
      ],
    },
    maps: {
      Front: [
        18.64406779661017, 20.40960451977401, 16.949152542372882,
        21.89265536723164, 15.819209039548022, 23.44632768361582,
        16.384180790960453, 25.0, 16.572504708097927, 26.059322033898304,
        16.760828625235405, 27.11864406779661, 16.195856873822976,
        28.24858757062147, 15.44256120527307, 29.661016949152543,
        15.819209039548022, 31.14406779661017, 16.195856873822976,
        32.27401129943503, 15.819209039548022, 33.40395480225989,
        26.365348399246706, 34.53389830508475, 26.930320150659135,
        33.26271186440678, 27.306967984934087, 32.06214689265537,
        28.436911487758945, 31.497175141242938, 29.001883239171374,
        28.46045197740113, 29.19020715630885, 24.364406779661017,
        28.436911487758945, 21.75141242937853, 25.235404896421844,
        20.550847457627118, 21.657250470809792, 20.127118644067796,
      ],
    },
  },
  CHEST_LEFT: {
    locationName: "Chest (L)",
    locationId: "CHEST_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: chestLeft,
          filename: "chestLeft.png",
        },
      ],
    },
    maps: {
      Front: [
        67.2316384180791, 30.7909604519774, 52.73069679849341,
        30.720338983050848, 52.73069679849341, 16.52542372881356,
        67.60828625235405, 18.502824858757062,
      ],
    },
  },
  CHEST_RIGHT: {
    locationName: "Chest (R)",
    locationId: "CHEST_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: chestRight,
          filename: "chestRight.png",
        },
      ],
    },
    maps: {
      Front: [
        32.76836158192091, 30.7909604519774, 47.26930320150659,
        30.720338983050848, 47.26930320150659, 16.52542372881356,
        32.39171374764595, 18.502824858757062,
      ],
    },
  },
  ABDOMEN_LEFT: {
    locationName: "Abdomen (L)",
    locationId: "ABDOMEN_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: abdomenLeft,
          filename: "abdomenLeft.png",
        },
      ],
    },
    maps: {
      Front: [
        54.23728813559322, 43.99717514124294, 71.37476459510358,
        42.443502824858754, 71.75141242937853, 44.13841807909605,
        72.50470809792844, 45.90395480225989, 73.44632768361582,
        47.387005649717516, 55.1789077212806, 48.44632768361582,
      ],
    },
  },
  ABDOMEN_RIGHT: {
    locationName: "Abdomen (R)",
    locationId: "ABDOMEN_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: abdomenRight,
          filename: "abdomenRight.png",
        },
      ],
    },
    maps: {
      Front: [
        44.76271186440678, 43.99717514124294, 27.625235404896422,
        42.443502824858754, 27.24858757062147, 44.13841807909605,
        26.495291902071564, 45.90395480225989, 25.55367231638418,
        47.387005649717516, 43.8210922787194, 48.44632768361582,
      ],
    },
  },
  THIGH_FLEXOR_LEFT: {
    locationName: "Thigh Flexor (L)",
    locationId: "THIGH_FLEXOR_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: thighLeft,
          filename: "thighLeft.png",
        },
      ],
    },
    maps: {
      Front: [
        51.03578154425612, 57.20338983050848, 74.57627118644068,
        55.7909604519774, 74.19962335216573, 57.344632768361585,
        73.82297551789077, 58.47457627118644, 73.44632768361582,
        59.675141242937855, 72.88135593220339, 61.016949152542374,
        72.12806026365348, 62.005649717514125, 71.37476459510358,
        62.994350282485875, 70.62146892655367, 63.983050847457626,
        51.9774011299435, 63.91242937853107, 51.9774011299435,
        62.85310734463277, 51.78907721280603, 61.440677966101696,
        51.78907721280603, 60.02824858757062, 51.60075329566855,
        58.40395480225989,
      ],
    },
  },
  THIGH_FLEXOR_RIGHT: {
    locationName: "Thigh Flexor (R)",
    locationId: "THIGH_FLEXOR_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: thighRight,
          filename: "thighRight.png",
        },
      ],
    },
    maps: {
      Front: [
        48.96421845574388, 57.20338983050848, 25.423728813559322,
        55.7909604519774, 25.800376647834273, 57.344632768361585,
        26.17702448210923, 58.47457627118644, 26.55367231638418,
        59.675141242937855, 27.11864406779661, 61.016949152542374,
        27.871939736346516, 62.005649717514125, 28.625235404896422,
        62.994350282485875, 29.37853107344633, 63.983050847457626,
        48.0225988700565, 63.91242937853107, 48.0225988700565,
        62.85310734463277, 48.21092278719397, 61.440677966101696,
        48.21092278719397, 60.02824858757062, 48.39924670433145,
        58.40395480225989,
      ],
    },
  },
  ANKLE_LEFT: {
    locationName: "Ankle (L)",
    locationId: "ANKLE_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: ankleFrontLeft,
          filename: "ankleFrontLeft.png",
        },
        {
          image: ankleBackLeft,
          filename: "ankleBackLeft.png",
        },
      ],
    },
    maps: {
      Front: [
        55.1789077212806, 90.60734463276836, 64.030131826742, 90.60734463276836,
        63.84180790960452, 91.66666666666667, 64.030131826742,
        92.51412429378531, 63.653483992467045, 93.2909604519774,
        64.40677966101696, 94.2090395480226, 54.61393596986817,
        94.27966101694915, 55.1789077212806, 93.36158192090396,
        55.1789077212806, 92.65536723163842, 54.80225988700565,
        91.87853107344633, 55.55555555555556, 91.24293785310735,
      ],
      Back: [
        43.712765957446805, 97.6116303219107, 42.91489361702128,
        96.88473520249221, 43.712765957446805, 95.74247144340602,
        43.180851063829785, 94.60020768431984, 43.180851063829785,
        93.6656282450675, 34.670212765957444, 93.56178608515057,
        35.202127659574465, 94.80789200415369, 35.734042553191486,
        95.95015576323988, 35.734042553191486, 96.88473520249221, 36.0,
        97.81931464174455,
      ],
    },
  },
  ANKLE_RIGHT: {
    locationName: "Ankle (R)",
    locationId: "ANKLE_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: ankleFrontRight,
          filename: "ankleFrontRight.png",
        },
        {
          image: ankleBackRight,
          filename: "ankleBackRight.png",
        },
      ],
    },
    maps: {
      Front: [
        43.3210922787194, 90.60734463276836, 34.46986817325801,
        90.60734463276836, 34.65819209039548, 91.66666666666667,
        34.46986817325801, 92.51412429378531, 34.846516007532955,
        93.2909604519774, 34.09322033898305, 94.2090395480226,
        43.88606403013183, 94.27966101694915, 43.3210922787194,
        93.36158192090396, 43.3210922787194, 92.65536723163842,
        43.69774011299435, 91.87853107344633, 42.94444444444444,
        91.24293785310735,
      ],
      Back: [
        54.787234042553195, 97.6116303219107, 55.58510638297872,
        96.88473520249221, 54.787234042553195, 95.74247144340602,
        55.319148936170215, 94.60020768431984, 55.319148936170215,
        93.6656282450675, 63.829787234042556, 93.56178608515057,
        63.297872340425535, 94.80789200415369, 62.765957446808514,
        95.95015576323988, 62.765957446808514, 96.88473520249221, 62.5,
        97.81931464174455,
      ],
    },
  },
  NECK: {
    locationName: "Neck",
    locationId: "NECK",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [],
    },
    maps: {
      Front: [
        41.24293785310734, 14.61864406779661, 42.93785310734463,
        13.983050847457626, 43.314500941619585, 12.853107344632768,
        42.3728813559322, 11.864406779661017, 57.6271186440678,
        11.864406779661017, 56.685499058380415, 12.853107344632768,
        57.06214689265537, 13.983050847457626, 58.75706214689266,
        14.61864406779661,
      ],
      Back: [
        42.819148936170215, 12.668743509865005, 43.351063829787236,
        13.603322949117342, 43.351063829787236, 14.641744548286605,
        42.287234042553195, 15.160955347871235, 57.712765957446805,
        15.160955347871235, 56.648936170212764, 14.641744548286605,
        56.648936170212764, 13.603322949117342, 57.180851063829785,
        12.668743509865005,
      ],
    },
  },
  FOREARM_FLEXOR_LEFT: {
    locationName: "Forearm Flexor (L)",
    locationId: "FOREARM_FLEXOR_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: forearmFlexorLeft,
          filename: "forearmFlexorLeft.png",
        },
      ],
    },
    maps: {
      Front: [
        90.20715630885122, 48.30508474576271, 89.26553672316385,
        46.32768361581921, 89.07721280602637, 44.13841807909605,
        88.70056497175142, 42.01977401129943, 88.51224105461394,
        40.46610169491525, 87.94726930320151, 38.91242937853107,
        87.00564971751412, 37.5, 75.14124293785311, 38.27683615819209,
        75.14124293785311, 39.759887005649716, 75.89453860640302,
        41.454802259887, 76.8361581920904, 43.14971751412429, 78.3427495291902,
        44.77401129943503, 79.84934086629002, 45.97457627118644,
        81.54425612052731, 47.740112994350284, 82.86252354048965,
        49.152542372881356,
      ],
    },
  },
  FOREARM_FLEXOR_RIGHT: {
    locationName: "Forearm Flexor (R)",
    locationId: "FOREARM_FLEXOR_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: forearmFlexorRight,
          filename: "forearmFlexorRight.png",
        },
      ],
    },
    maps: {
      Front: [
        9.792843691148775, 48.30508474576271, 10.734463276836157,
        46.32768361581921, 10.922787193973635, 44.13841807909605,
        11.299435028248588, 42.01977401129943, 11.487758945386064,
        40.46610169491525, 12.052730696798493, 38.91242937853107,
        12.994350282485875, 37.5, 24.858757062146893, 38.27683615819209,
        24.858757062146893, 39.759887005649716, 24.105461393596986,
        41.454802259887, 23.163841807909606, 43.14971751412429,
        21.657250470809792, 44.77401129943503, 20.150659133709983,
        45.97457627118644, 18.455743879472692, 47.740112994350284,
        17.137476459510356, 49.152542372881356,
      ],
    },
  },

  UPPER_BACK_RIGHT: {
    locationName: "Upper Back (R)",
    locationId: "UPPER_BACK_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: upperBackRight,
          filename: "upperBackRight.png",
        },
      ],
    },
    maps: {
      Back: [
        51.59574468085106, 18.38006230529595, 67.2872340425532,
        21.079958463136034, 67.2872340425532, 34.47559709241952,
        51.59574468085106, 34.47559709241952,
      ],
    },
  },
  UPPER_BACK_LEFT: {
    locationName: "Upper Back (L)",
    locationId: "UPPER_BACK_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: upperBackLeft,
          filename: "upperBackLeft.png",
        },
      ],
    },
    maps: {
      Back: [
        48.40425531914894, 18.38006230529595, 32.712765957446805,
        21.079958463136034, 32.712765957446805, 34.47559709241952,
        48.40425531914894, 34.47559709241952,
      ],
    },
  },
  LOWER_BACK_LEFT: {
    locationName: "Lower Back (L)",
    locationId: "LOWER_BACK_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: lowerBackLeft,
          filename: "lowerBackLeft.png",
        },
      ],
    },
    maps: {
      Back: [
        25.79787234042553, 49.32502596053998, 45.744680851063826,
        49.11734164070613, 45.212765957446805, 42.88681204569055,
        29.25531914893617, 44.02907580477674, 27.925531914893618,
        45.27518172377985, 26.595744680851062, 46.93665628245068,
      ],
    },
  },
  LOWER_BACK_RIGHT: {
    locationName: "Lower Back (R)",
    locationId: "LOWER_BACK_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: lowerBackRight,
          filename: "lowerBackRight.png",
        },
      ],
    },
    maps: {
      Back: [
        74.20212765957447, 49.32502596053998, 54.255319148936174,
        49.11734164070613, 54.787234042553195, 42.88681204569055,
        70.74468085106383, 44.02907580477674, 72.07446808510639,
        45.27518172377985, 73.40425531914893, 46.93665628245068,
      ],
    },
  },
  UPPER_ARM_EXTENSOR_LEFT: {
    locationName: "Upper Arm Extensor (L)",
    locationId: "UPPER_ARM_EXTENSOR_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: upperArmExtensorLeft,
          filename: "upperArmExtensorLeft.png",
        },
      ],
    },
    maps: {
      Back: [
        26.06382978723404, 17.86085150571132, 23.138297872340427,
        18.483904465212877, 21.01063829787234, 19.21079958463136,
        19.148936170212767, 20.145379023883695, 17.28723404255319,
        21.287642782969886, 16.48936170212766, 23.052959501557634,
        15.691489361702128, 25.233644859813083, 16.75531914893617,
        26.375908618899274, 16.22340425531915, 28.037383177570092,
        15.691489361702128, 29.179646936656283, 15.691489361702128,
        30.8411214953271, 15.691489361702128, 32.398753894081,
        15.957446808510639, 34.164070612668745, 26.329787234042552,
        34.3717549325026, 27.393617021276597, 33.12564901349948,
        28.45744680851064, 30.737279335410175, 30.851063829787233,
        26.687435098650052, 31.648936170212767, 22.429906542056074,
        30.0531914893617, 19.314641744548286,
      ],
    },
  },
  UPPER_ARM_EXTENSOR_RIGHT: {
    locationName: "Upper Arm Extensor (R)",
    locationId: "UPPER_ARM_EXTENSOR_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: upperArmExtensorRight,
          filename: "upperArmExtensorRight.png",
        },
      ],
    },
    maps: {
      Back: [
        73.93617021276596, 17.86085150571132, 76.86170212765957,
        18.483904465212877, 78.98936170212765, 19.21079958463136,
        80.85106382978724, 20.145379023883695, 82.7127659574468,
        21.287642782969886, 83.51063829787235, 23.052959501557634,
        84.30851063829788, 25.233644859813083, 83.24468085106383,
        26.375908618899274, 83.77659574468085, 28.037383177570092,
        84.30851063829788, 29.179646936656283, 84.30851063829788,
        30.8411214953271, 84.30851063829788, 32.398753894081, 84.04255319148936,
        34.164070612668745, 73.67021276595744, 34.3717549325026,
        72.6063829787234, 33.12564901349948, 71.54255319148936,
        30.737279335410175, 69.14893617021276, 26.687435098650052,
        68.35106382978724, 22.429906542056074, 69.94680851063829,
        19.314641744548286,
      ],
    },
  },
  CALF_RIGHT: {
    locationName: "Calf (R)",
    locationId: "CALF_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: calfRight,
          filename: "calfRight.png",
        },
      ],
    },
    maps: {
      Back: [
        54.52127659574468, 78.29698857736241, 69.14893617021276,
        78.19314641744548, 69.68085106382979, 79.85462097611631,
        69.94680851063829, 81.30841121495327, 69.41489361702128,
        82.96988577362409, 68.35106382978724, 84.83904465212876,
        67.55319148936171, 86.91588785046729, 66.22340425531915,
        88.5773624091381, 65.69148936170212, 90.03115264797508,
        55.319148936170215, 90.03115264797508, 54.787234042553195,
        88.36967808930426, 53.45744680851064, 86.81204569055036,
        52.92553191489362, 85.35825545171339, 52.659574468085104,
        83.28141225337487, 52.92553191489362, 81.30841121495327,
        53.723404255319146, 79.64693665628245,
      ],
    },
  },
  CALF_LEFT: {
    locationName: "Calf (L)",
    locationId: "CALF_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: calfLeft,
          filename: "calfLeft.png",
        },
      ],
    },
    maps: {
      Back: [
        43.97872340425532, 78.29698857736241, 29.351063829787233,
        78.19314641744548, 28.819148936170212, 79.85462097611631,
        28.5531914893617, 81.30841121495327, 29.085106382978722,
        82.96988577362409, 30.148936170212767, 84.83904465212876,
        30.9468085106383, 86.91588785046729, 32.276595744680854,
        88.5773624091381, 32.808510638297875, 90.03115264797508,
        43.180851063829785, 90.03115264797508, 43.712765957446805,
        88.36967808930426, 45.04255319148936, 86.81204569055036,
        45.57446808510638, 85.35825545171339, 45.840425531914896,
        83.28141225337487, 45.57446808510638, 81.30841121495327,
        44.776595744680854, 79.64693665628245,
      ],
    },
  },

  FOREARM_EXTENSOR_LEFT: {
    locationName: "Forearm Extensor (L)",
    locationId: "FOREARM_EXTENSOR_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: forearmExtensorLeft,
          filename: "forearmExtensorLeft.png",
        },
      ],
    },
    maps: {
      Back: [
        25.0, 39.56386292834891, 14.095744680851064, 37.69470404984423,
        12.23404255319149, 39.66770508826583, 11.702127659574469,
        41.74454828660436, 10.904255319148936, 44.02907580477674,
        11.170212765957446, 45.482866043613704, 10.904255319148936,
        47.24818276220145, 10.106382978723405, 49.11734164070613,
        17.5531914893617, 49.94807892004154, 19.414893617021278,
        48.28660436137071, 20.74468085106383, 46.625129802699895,
        22.606382978723403, 44.755970924195225, 24.20212765957447,
        42.15991692627207,
      ],
    },
  },
  FOREARM_EXTENSOR_RIGHT: {
    locationName: "Forearm Extensor (R)",
    locationId: "FOREARM_EXTENSOR_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: forearmExtensorRight,
          filename: "forearmExtensorRight.png",
        },
      ],
    },
    maps: {
      Back: [
        75.0, 39.56386292834891, 85.90425531914893, 37.69470404984423,
        87.76595744680851, 39.66770508826583, 88.29787234042553,
        41.74454828660436, 89.09574468085107, 44.02907580477674,
        88.82978723404256, 45.482866043613704, 89.09574468085107,
        47.24818276220145, 89.8936170212766, 49.11734164070613,
        82.44680851063829, 49.94807892004154, 80.58510638297872,
        48.28660436137071, 79.25531914893617, 46.625129802699895,
        77.3936170212766, 44.755970924195225, 75.79787234042553,
        42.15991692627207,
      ],
    },
  },
  DORSAL_HAND_RIGHT: {
    locationName: "Dorsal Hand (R)",
    locationId: "DORSAL_HAND_RIGHT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: dorsalHandRight,
          filename: "dorsalHandRight.png",
        },
      ],
    },
    maps: {
      Back: [
        16.48936170212766, 51.298026998961575, 9.574468085106384,
        50.571131879543096, 8.77659574468085, 51.60955347871236,
        5.585106382978723, 52.440290758047766, 15.425531914893616,
        56.386292834890966, 15.957446808510639, 54.72481827622015,
        16.75531914893617, 52.75181723779855,
      ],
    },
  },
  DORSAL_HAND_LEFT: {
    locationName: "Dorsal Hand (L)",
    locationId: "DORSAL_HAND_LEFT",
    parameterId: "STL",
    CSI: { samplesNeeded: 3 },
    BMODE: { samplesNeeded: 1 },
    instruction: {
      text: "When acquiring a T-Mode sample, slowly drag the transducer wand along the skin in a swipe like motion for a distance of approximately two inches. The T-Mode acquisition lasts five seconds. When acquiring subsequent E-Mode samples, hold the transducer steady on the skin. The E-Mode acquisition lasts two seconds.",
      illustration: [
        {
          image: dorsalHandLeft,
          filename: "dorsalHandLeft.png",
        },
      ],
    },
    maps: {
      Back: [
        83.51063829787235, 51.298026998961575, 90.42553191489361,
        50.571131879543096, 91.22340425531915, 51.60955347871236,
        94.41489361702128, 52.440290758047766, 84.57446808510639,
        56.386292834890966, 84.04255319148936, 54.72481827622015,
        83.24468085106383, 52.75181723779855,
      ],
    },
  },
};
